import React, { useState, useEffect } from "react";
import {
  Select,
  Collapse,
  Input,
  Card,
  Empty,
  Spin,
  Tag,
  Avatar,
  Tabs,
  Divider,
  Modal,
} from "antd";
import {
  SearchOutlined,
  TeamOutlined,
  UserOutlined,
  TrophyOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import styles from "./Commentry.module.css";

import {
  GetRaces,
  GetSchools,
  GetRowers,
  GetEventEntries,
} from "../../APIManager";

const { Panel } = Collapse;
const { Search } = Input;
const { TabPane } = Tabs;

const CommentryPage = () => {
  const [races, SetRaces] = useState([]);
  const [schools, SetSchools] = useState([]);
  const [rowers, SetRowers] = useState([]);
  const [eventEntries, SetEventEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  const [selectedRace, SetSelectedRace] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRower, setSelectedRower] = useState(null);

  useEffect(() => {
    Promise.all([
      GetRaces(),
      GetSchools(),
      GetRowers(),
      GetEventEntries(),
    ]).then(([racesRes, schoolsRes, rowersRes, entriesRes]) => {
      SetRaces(racesRes.data);
      SetSchools(schoolsRes.data);
      SetRowers(rowersRes.data);
      SetEventEntries(entriesRes.data);
      setLoading(false);
    });
  }, []);

  console.log(selectedRower);

  // Filter rowers based on search query and sort alphabetically
  const filteredRowers = rowers
    .filter((rower) =>
      rower.Name?.toLowerCase().includes(searchQuery.toLowerCase()),
    )
    .sort((a, b) => a.Name?.localeCompare(b.Name));

  // Get school name by ID
  const getSchoolName = (schoolId) => {
    console.log(schoolId);
    const school = schools.find((s) => s._id == schoolId);
    return school?.schoolname || "Unknown School";
  };

  // Get school initials by ID
  const getSchoolInitials = (schoolId) => {
    const school = schools.find((s) => s._id === schoolId);
    return school?.schoolinitials || "N/A";
  };

  if (loading) {
    return (
      <div className={styles.LoadingContainer}>
        <Spin size="large" />
        <p>Loading Commentary Data...</p>
      </div>
    );
  }

  var race;
  if (selectedRace) {
    race = races.filter((r) => r.RaceName == selectedRace)[0];
  }

  return (
    <div className={styles.PageContainer}>
      <div className={styles.PageHeader}>
        <h1 className={styles.PageTitle}>Race Commentary</h1>
        <p>
          Total Rowers with Bios Submitted:{" "}
          {rowers.filter((rower) => rower.Bio).length}
        </p>
      </div>
      <Card className={styles.MainCard}>
        <Tabs defaultActiveKey="1" size="large" className={styles.MainTabs}>
          <TabPane
            tab={
              <span>
                <TrophyOutlined /> Race Commentary
              </span>
            }
            key="1"
          >
            <div className={styles.TabContent}>
              <div className={styles.SectionHeader}>
                <span>Select a Race to View Participants</span>
              </div>

              <Select
                className={styles.RaceSelect}
                placeholder="Search and select a race..."
                showSearch
                allowClear
                size="large"
                options={races.map((e) => ({
                  value: e.RaceName,
                  label: e.RaceName,
                }))}
                onChange={(e) => SetSelectedRace(e)}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
              />

              {selectedRace ? (
                <div className={styles.RaceParticipants}>
                  <div className={styles.RaceHeader}>
                    <h3>{selectedRace}</h3>
                    <Tag color="blue">
                      {race?.Participants?.filter((p) => !p.isPlaceHolder)
                        .length || 0}{" "}
                      Teams
                    </Tag>
                  </div>

                  <Collapse
                    className={styles.TeamsCollapse}
                    expandIconPosition="end"
                  >
                    {race?.Participants?.filter((p) => !p.isPlaceHolder).map(
                      (p, i) => {
                        var school = schools.filter(
                          (s) => s._id == p.school,
                        )[0];
                        var entry = eventEntries.filter(
                          (e) =>
                            e.RaceName == race.EventName && e.Team == p.school,
                        )[0];

                        if (!entry) return null;

                        var students = [
                          ...entry.Rowers,
                          ...entry.Coxers,
                          ...entry.SubCoxers,
                        ];

                        return (
                          <Panel
                            key={`Panel-${i}`}
                            header={
                              <div className={styles.PanelHeader}>
                                <span className={styles.SchoolName}>
                                  {school?.schoolname}
                                </span>
                              </div>
                            }
                          >
                            <div className={styles.CrewGrid}>
                              {students.map((s, idx) => {
                                var rower = rowers.filter((r) => r._id == s)[0];
                                if (!rower) return null;

                                return (
                                  <div key={idx} className={styles.RowerCard}>
                                    <div className={styles.RowerAvatar}>
                                      <Avatar
                                        size={36}
                                        icon={<UserOutlined />}
                                        src={`https://adminapi.kbcrowing.org/DownloadFile/${encodeURIComponent(
                                          rower.Photograph,
                                        )}`}
                                        className={styles.Avatar}
                                      />
                                    </div>
                                    <div className={styles.RowerInfo}>
                                      <div className={styles.RowerName}>
                                        {rower.Name}
                                      </div>
                                      <div className={styles.RowerBio}>
                                        {rower.Bio || (
                                          <span className={styles.NoBio}>
                                            No bio available
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </Panel>
                        );
                      },
                    )}
                  </Collapse>
                </div>
              ) : (
                <div className={styles.EmptyState}>
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Select a race to view team details and rower bios"
                  />
                </div>
              )}
            </div>
          </TabPane>

          <TabPane
            tab={
              <span>
                <SearchOutlined /> Rower Search
              </span>
            }
            key="2"
          >
            <div className={styles.TabContent}>
              <div className={styles.SectionHeader}>
                <SearchOutlined className={styles.SectionIcon} />
                <span>Search for Any Rower</span>
              </div>

              <Search
                placeholder="Enter rower name to search..."
                allowClear
                enterButton="Search"
                size="large"
                className={styles.RowerSearch}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                }}
                value={searchQuery}
              />

              {filteredRowers.length > 0 ? (
                <div className={styles.RowersList}>
                  {filteredRowers.map((rower, idx) => (
                    <div
                      key={idx}
                      className={`${styles.RowerListItem} ${
                        selectedRower?._id === rower._id ? styles.Selected : ""
                      }`}
                      onClick={() => setSelectedRower(rower)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          flex: 1,
                        }}
                      >
                        <Avatar
                          size={40}
                          icon={<UserOutlined />}
                          /* src={`https://adminapi.kbcrowing.org/DownloadFile/${encodeURIComponent(
                            rower.Photograph,
                          )}`} */
                        />
                        <div className={styles.RowerListInfo}>
                          <div className={styles.RowerListName}>
                            {rower.Name}
                          </div>
                          <Tag color="blue" size="small">
                            {getSchoolInitials(rower.Team._id)}
                          </Tag>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          fontSize: "0.8rem",
                          color: "#1890ff",
                          marginLeft: "12px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        View Bio
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <Empty description="No rowers found matching your search" />
              )}

              {selectedRower && (
                <Modal
                  title=""
                  visible={true}
                  onCancel={() => setSelectedRower(null)}
                  footer={null}
                  width={800}
                >
                  <div style={{ marginTop: "20px" }}>
                    {/* Avatar and Info Header */}
                    <div
                      style={{
                        textAlign: "center",
                        marginBottom: "30px",
                        paddingBottom: "20px",
                        borderBottom: "1px solid #f0f0f0",
                      }}
                    >
                      <Avatar
                        size={100}
                        icon={<UserOutlined />}
                        src={`https://adminapi.kbcrowing.org/DownloadFile/${encodeURIComponent(
                          selectedRower.Photograph,
                        )}`}
                        style={{
                          border: "4px solid #1890ff",
                          marginBottom: "15px",
                          display: "block",
                          margin: "0 auto 15px",
                        }}
                      />
                      <h2 style={{ margin: "0 0 12px 0", color: "#1a1a2e" }}>
                        {selectedRower.Name}
                      </h2>
                      <Tag
                        color="blue"
                        style={{ fontSize: "0.95rem", padding: "6px 12px" }}
                      >
                        {selectedRower.Team.schoolname}
                      </Tag>
                    </div>

                    {/* Bio Section */}
                    <div
                      className={styles.BioSection}
                      style={{ marginBottom: "25px" }}
                    >
                      <div
                        className={styles.BioLabel}
                        style={{ marginBottom: "12px" }}
                      >
                        <InfoCircleOutlined /> Bio
                      </div>
                      <div className={styles.BioContent}>
                        {selectedRower.Bio || (
                          <span className={styles.NoBio}>
                            No bio has been added for this rower yet.
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Additional Details */}
                    {(selectedRower.Gender || selectedRower.AgeGroup) && (
                      <div
                        style={{
                          borderTop: "1px solid #f0f0f0",
                          paddingTop: "15px",
                        }}
                      >
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "20px",
                          }}
                        >
                          {selectedRower.Gender && (
                            <div>
                              <span
                                className={styles.DetailLabel}
                                style={{
                                  display: "block",
                                  marginBottom: "6px",
                                }}
                              >
                                Gender
                              </span>
                              <span style={{ fontSize: "1rem", color: "#333" }}>
                                {selectedRower.Gender}
                              </span>
                            </div>
                          )}
                          {selectedRower.AgeGroup && (
                            <div>
                              <span
                                className={styles.DetailLabel}
                                style={{
                                  display: "block",
                                  marginBottom: "6px",
                                }}
                              >
                                Age Group
                              </span>
                              <span style={{ fontSize: "1rem", color: "#333" }}>
                                {selectedRower.AgeGroup}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </Modal>
              )}

              {!selectedRower && filteredRowers.length === 0 && (
                <div className={styles.EmptyState}>
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No rowers found matching your search"
                  />
                </div>
              )}
            </div>
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default CommentryPage;
